import { addMatchedMentor } from '../api/mentor_matches';

export const findAndSetMentor = (callbacks = {}, context) => {
  const { onMentorFound, onSetPatientPartner, onNoMentorFound } = callbacks;

  const timer = setTimeout(() => {
    addMatchedMentor(
      (data) => {
        context.auth.userUpdate({ matched_with_mentor: true }, () => {});

        if (onSetPatientPartner) {
          onSetPatientPartner(data);
          sessionStorage.setItem('patientPartner', JSON.stringify(data));
        }

        if (onMentorFound) {
          onMentorFound(true);
        }
      },
      () => {
        if (onNoMentorFound) {
          onNoMentorFound();
          sessionStorage.removeItem('patientPartner');
        }
      }
    );
  }, 3000);
  return () => clearTimeout(timer);
};
